import { createLabeledMessages } from '../../../messageUtils';
const generic = {
    fullErrorMessage: 'Full error message',
    copyError: 'Copy data for HelpDesk',
    showFullError: 'Show full error description',
    hideFullError: 'Hide full error description',
    detailError: 'Show error detail',
    copyAllErrors: 'Copy data about all errors',
    overviewOfErrors: 'Overview of errors',
    uniqueIdentifier: 'Unique error identifier',
    errorDescription: 'Error description',
    closeError: 'Close error',
    noVisibleErrors: 'There are no visible errors',
    sendError: 'Send error message',
    sendAllErrors: 'Send all errors',
    errorSent: 'Error message sent',
    errorNotSent: 'Error message could not be sent',
    loadCduErrorHeading: 'Cannot load user from CDU',
    loadCduShortDescription: 'Please contact helpdesk and logout.',
    hideError: 'Hide error',
    hideAll: 'Hide all',
    notifierTitle: 'List of errors'
};
const messages = Object.assign({}, generic);
export default Object.assign({}, messages, createLabeledMessages(messages));
